import {createSvgIcon} from "@mui/material";

const TelegramIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="27" viewBox="0 0 26 27" fill="none">
    <path fillRule="evenodd" clipRule="evenodd"
          d="M16.5131 20.0185C17.4218 20.4019 17.7625 19.5987 17.7625 19.5987L20.1667 7.95252C20.1477 7.16759 19.0498 7.6422 19.0498 7.6422L5.59039 12.7351C5.59039 12.7351 4.94676 12.9542 5.00355 13.3375C5.06034 13.7208 5.57146 13.9034 5.57146 13.9034L8.95997 14.9986C8.95997 14.9986 9.9822 18.2296 10.1904 18.8503C10.3797 19.4526 10.5501 19.4709 10.5501 19.4709C10.7394 19.5439 10.9098 19.4161 10.9098 19.4161L13.1057 17.4994L16.5131 20.0185ZM17.1 10.0151C17.1 10.0151 17.5732 9.74126 17.5543 10.0151C17.5543 10.0151 17.63 10.0516 17.3839 10.3071C17.1568 10.5262 11.7995 15.1627 11.0802 15.7834C11.0234 15.8199 10.9855 15.8747 10.9855 15.9477L10.7773 17.6636C10.7394 17.8461 10.4933 17.8644 10.4365 17.7001L9.54681 14.8889C9.50895 14.7794 9.54681 14.6516 9.66039 14.5786L17.1 10.0151Z"
          fill="currentColor"/>
  </svg>,
  'Telegram',
)

export default TelegramIcon
